import { callAPI } from '../network';

export async function getProfile (companyId){
  
   const data = await callAPI(
                        null, 
                        `ManagementProfile/GetByCompanyId?CompanyId=${companyId}`, 'get');
   return data || [ ];
}


export async function getApplication(companyId){
  
   const data = await callAPI(
                        null, 
                        `ManagementProfile/GetApplication?companyId=${companyId}`, 'get');
   return data || [ ];
}

export async function GetProfilesByApplicationId (Id, companyId){
  
   const data = await callAPI(
                        null, 
                        `ManagementProfile/GetProfileByApplication?id=${Id}&companyId=${companyId}`, 'get');
   return data || [ ];
}

export async function GetApplicationByProfileId (Id, companyId){
   const data = await callAPI(
                        null,
                        `ManagementProfile/GetApplicationByProfile?Id=${Id}&companyId=${companyId}`, 'get');
   return data || [ ];
}

export async function getPermissions (){
  
   const data = await callAPI(
                        null, 
                        'ManagementEmployee/GetAllPermissions', 'get');
   return data || [ ];
}

export async function getProfileById (id){

    const data = await callAPI(
                         null, 
                         'ManagementProfile/GetById?id='+ id, 'get');
    return data;
 }

 export async function saveProfile (customer){
   const method = customer.id ? 'put' : 'post';
   //console.log(customer);
   const data = await callAPI(
                        customer, 
                        'ManagementProfile', method);
   return data;
}

export async function savePermissions (permissions,profileId,profileName,employee,companyId){
   const params = {
         permission: permissions.permissions.map(permission => ({
         Code: permission.Code, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
         Description: permission.Description, // Igualmente aquí.
         Id: permission.Id
       })),
       profileId: profileId,
       profileName: profileName,
       employee: employee
    };
    //console.log('entro');
   //console.log(params);
   const data = await callAPI(
      params, `Security/updatePermissionsByProfile/${companyId}`, 'post');
return data || [ ];
}

export async function deleteProfile (id, employee){
   const data = await callAPI(
                        null, 
                        `ManagementProfile?id=${id}&employee=${employee}`, 'delete');
   return data;
}

export async function getAllProfilesByEmployeePosition(companyId,employeePositionId){
   let data;
   if (employeePositionId) {
      data = await callAPI(
         null, 
         `Security/getProfilesByEmployeePosition?companyId=${companyId}&employeePositionId=${employeePositionId}`, 'get');

      
   } else {
      data = await callAPI(
         null, 
         `Security/getAllProfilesByEmployeePosition?companyId=${companyId}`, 'get');

   }
  
   return data || [ ];
}

export async function getAllPermissionsByProfile(profileId){
   let data;
   if (profileId) {
      data = await callAPI(
         null, 
         'Security/getPermissionsByProfile?profileId='+ profileId, 'get');

      
   } else {
      data = await callAPI(
         null, 
         'Security/getAllPermissionsByProfile', 'get');

   }
  
   return data || [ ];
}


export async function updateProfilesByPosition (profiles,employeePositionId, employee ){

   //console.log(profiles);
   const params = {
      profile: profiles.profiles.map(profile => ({
         Id: profile.Id, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
         Description: profile.Description // Igualmente aquí.
       })),
       employeePositionId: profiles.employeePositionId,
       employee: employee
    };

   
   const data = await callAPI(
                  params, 
                        'Security/updateProfilesByPosition', 'post');
   return data || [ ];
}